import {Button, Grid, styled} from "@mui/material"
import React from "react"

const StyledGrid = styled(Grid)(({theme}) => theme.HEROUNIT.container)
const StyledText = styled(Grid)(({theme}) => theme.HEROUNIT.label)
const StyledButton = styled(Button)(({theme}) => theme.HEROUNIT.button)

const HeroUnitWidget = ({ widget: inputWidget, value, triggerAction }) => {
  const widget = {
    ...inputWidget,
    ...(value?.dataType === "widget" ? value : {}),
  };

  const handleClick = () => {
    widget.action && triggerAction(widget.action, widget.target);
  };

  return (
    <StyledGrid container>
      <StyledText
        variant="h5" 
      >
        {widget.text}
      </StyledText>

      <StyledButton
        variant="primary"
        onClick={handleClick}
      >
        {widget.subtext}
      </StyledButton>
    </StyledGrid>
  );
};

export default HeroUnitWidget;